<template>
  <div>
    <select multiple v-model="selectedRoles">
      <option v-for="(role, index) in roles" :value="role.name" :key="index">
        {{ role.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("roles/read");
  },
  props: {
    value: {
      required: true,
      default: () => []
    },
    attribute: {
      required: true,
      type: Object
    }
  },
  computed: {
    roles() {
      return this.$store.getters["roles/all"];
    },
    selectedRoles: {
      get() {
        return this.value || [];
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    }
  }
};
</script>

<style></style>
